import { render, staticRenderFns } from "./WaitingList-ResultTest.vue?vue&type=template&id=80e4b77a&scoped=true&"
import script from "./WaitingList-ResultTest.js?vue&type=script&lang=js&"
export * from "./WaitingList-ResultTest.js?vue&type=script&lang=js&"
import style0 from "./WaitingList-ResultTest.vue?vue&type=style&index=0&id=80e4b77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e4b77a",
  null
  
)

export default component.exports